import { useEffect } from 'react'
import { Outlet } from 'react-router'

import HexaV2SideBarMenu from '@/components/business/HexaV2SidebarMenu'
import SupportChat from '@/components/business/SupportChat'
import { startFloatingLayoutSync } from '@/styles/floatingLayoutSync'
import AppProvider from '@/contexts'
import { OnlinePaymentProvider } from '@/contexts/onlinePayment'

import RedirectRules from './RedirectRules'
import * as S from './styles'

export { requireAuth } from './requireAuth'

export function AuthenticatedLayout() {
  useEffect(() => {
    return startFloatingLayoutSync()
  }, [])

  return (
    <AppProvider>
      <RedirectRules />
      <OnlinePaymentProvider>
        <S.Container>
          <HexaV2SideBarMenu />
          <S.MainColumn>
            <S.RouteContent>
              <SupportChat />
              <Outlet />
            </S.RouteContent>
          </S.MainColumn>
        </S.Container>
      </OnlinePaymentProvider>
    </AppProvider>
  )
}
